import { ForecastDeclineTypeBase } from './base/forecast-decline-type-base';

export class ForecastDeclineType extends ForecastDeclineTypeBase { }